export default __webpack_public_path__ + "static/media/mobile-it.a18913ec.png";